"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BpmnError = void 0;
/**
 * This type can be used to throw an error modeled at an ErrorEndEvent.
 */
class BpmnError extends Error {
    constructor(name, code, message) {
        super(message !== null && message !== void 0 ? message : name);
        this.name = name;
        this.code = code !== null && code !== void 0 ? code : '';
        this.message = message !== null && message !== void 0 ? message : '';
    }
}
exports.BpmnError = BpmnError;
//# sourceMappingURL=BpmnError.js.map